/**
 * @deprecated
 */
export function removeObjPropertyImmutably<T>(
  obj: T,
  props: (keyof T)[] | keyof T,
) {
  if (!Array.isArray(props)) props = [props];
  if (obj === Object(obj)) {
    const newObj = Object(obj);
    return Object.fromEntries(
      Object.entries(newObj).filter(([key]) => !props.toString().includes(key)),
    ) as T;
  }
  return obj;
}
